import React, { Component } from 'react';


class Header extends Component {
  render() {
    return (
        <div className="navbar navbar-expand-lg fixed-top navbar-dark bg-primary">
        <div className="container">
          <a href="../" className="navbar-brand">ICE BreakRRR</a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav">
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" id="themes">Meet Ups</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="http://blog.bootswatch.com">Blog</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="../help/">Help</a>
              </li>
            </ul>
            <ul className="nav navbar-nav ml-auto">
              <li className="nav-item">
                <a className="nav-link" href="http://builtwithbootstrap.com/" target="_blank">My Account <span className="caret"></span></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js